<template>
    <tr class="rate-history-row rate-history-row-data">
        <slot name="prepend-cells"></slot>
        <td v-bind:class="{'field-updated': isFieldUpdated('type')}">
            <span class="glyphicon glyphicon-time"></span>
            {{ rateType }}
        </td>
        <td v-bind:class="{'field-updated': isFieldUpdated('market_group_id')}">
            <span v-if="rate.market_group">{{ rate.market_group.name }}</span>
            <em v-else class="text-muted">Unknown</em>
        </td>
        <td v-bind:class="{'field-updated': isFieldUpdated('expiration_date')}">{{ expirationDate }}</td>
        <td v-bind:class="{'field-updated': isFieldUpdated('rate')}">{{ rate.rate }}%</td>
        <td v-bind:class="{'field-updated': isFieldUpdated('intro_term')}">{{ rate.intro_term }} Mos.</td>
        <td v-bind:class="{'field-updated': isFieldUpdated('post_intro_rate')}">{{ rate.post_intro_rate }}%</td>
        <td v-bind:class="{'field-updated': isFieldUpdated('term')}">
            <span v-if="rate.term !== null">{{ termInYears }} Yrs.</span>
            <em v-else class="text-muted">N/A</em>
        </td>
        <td v-bind:class="{'field-updated': isFieldUpdated('loan_amount_min')}">${{ rate.loan_amount_min }}</td>
        <td v-bind:class="{'field-updated': isFieldUpdated('loan_amount_max')}">${{ rate.loan_amount_max }}</td>
        <td v-bind:class="{'field-updated': isFieldUpdated('fee_amount') || isFieldUpdated('fee_type')}">
            <template v-if="rate.fee_type == 'percent'">{{ rate.fee_amount }}%</template>
            <template v-else>${{ rate.fee_amount }}</template>
        </td>
        <td v-bind:class="{'field-updated': isFieldUpdated('draw_amount')}">${{ rate.draw_amount }}</td>
        <td v-bind:class="{'field-updated': isFieldUpdated('fico_min')}">{{ rate.fico_min }}</td>
        <td v-bind:class="{'field-updated': isFieldUpdated('fico_max')}">{{ rate.fico_max }}</td>
        <td v-bind:class="{'field-updated': isFieldUpdated('ltv_min')}">{{ rate.ltv_min }}%</td>
        <td v-bind:class="{'field-updated': isFieldUpdated('ltv_max')}">{{ rate.ltv_max }}%</td>
        <td><abbr :title="rate.description">{{ rate.updated_at }}</abbr></td>
        <td>
            <span v-if="rate.is_old">Prior</span>
            <span v-else>{{ rate.activity }}</span>
        </td>
        <slot name="append-cells"></slot>
    </tr>
</template>

<script>
    export default {
        name: 'rate-list-data-history-row',
        props: {
            rate: {
                type: Object
            },
        },
        computed: {
            expirationDate () {
                return moment(this.rate.expiration_date).format('MM/DD/YYYY')
            },
            rateType () {
                return this.rate.type.replace(/-/g, ' ');
            },
            termInYears () {
                if (this.rate.term === null) {
                    return null;
                }
                return Math.floor(this.rate.term / 12);
            },
            disabled () {
                return this.loading;
            }
        },
        methods: {
            isFieldUpdated(fieldname) {
                const properties = this.rate.properties || {};
                const old = properties.old || false;
                if (!old) {
                    return false;
                }
                const current = properties.attributes || {};
                
                return old[fieldname] !== current[fieldname];
            }
        }
    }
</script>